module.exports = __webpack_public_path__ + "static/media/time_icon.dce7c8ca.svg";